import CreditLifeSignature from './CreditLifeSignature'

export default CreditLifeSignature
